// extracted by mini-css-extract-plugin
export var active = "_m6-2";
export var recordingDot = "_m6-1";
export var recordingIndicator = "_m6-0";